var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/sysText" } } }, [
              _c("div", { staticClass: "div1" }, [_vm._v("系统文件")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("编辑系统文件")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content", staticStyle: { "padding-bottom": "40px" } },
      [
        _c("h2", [_vm._v(_vm._s(_vm.breadcrumbTitle))]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "cuponForm",
                staticClass: "info-form",
                attrs: {
                  model: _vm.cuponForm,
                  rules: _vm.cuponRules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "标题", prop: "title" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "450px" },
                      attrs: {
                        placeholder: "请输入标题",
                        maxlength: "14",
                        "show-word-limit": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cuponForm.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "title", $$v)
                        },
                        expression: "cuponForm.title",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "brand-id",
                    attrs: { label: "内容", prop: "content" },
                  },
                  [
                    _c("quill-editor", {
                      ref: "myQuillEditor",
                      staticClass: "editor",
                      attrs: { options: _vm.editorOption },
                      model: {
                        value: _vm.cuponForm.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.cuponForm, "content", $$v)
                        },
                        expression: "cuponForm.content",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "bottom",
                        staticStyle: { display: "none" },
                      },
                      [
                        _c("el-upload", {
                          ref: "uploadicon",
                          staticClass: "centerImg",
                          attrs: {
                            action: " ",
                            "list-type": "picture-card",
                            "auto-upload": false,
                            "on-change": _vm.handleAvatarChangeIcon,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "content bottom-but" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submitFn } },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }